import React from 'react'
import { Link } from 'react-router-dom'

// props should contain:
// player {
//  name
//  playerId
//  score
//  isWinner
// }
const PlayerName = (player) => {
  const c = "player " + (player.isWinner ? "winner" : "loser");
  const l = '/playerinfo/' + player.playerId;

  return (
    <tr key={player.playerId} className="scoreTr">
      <td className="scoreTdPlayerName">
        <Link to={l}>
          <div className={c}>{player.playerName}</div>
        </Link>
      </td>
      <td className="scoreTdPlayerScore">
        <Link to={l}>
          <div className={c}>{player.score}</div>
        </Link>
      </td>
    </tr>
  );
}

export default PlayerName;



// WEBPACK FOOTER //
// ./src/components/PlayerName.js